<template>
  <div ref="TUESVolumeCardpdf" id="TUESVolumeCardpdf">
    <section class="dashboard">
      <div>
         <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      </div>
      <b-card class="mainCardBG" v-if="showDash == true">
        <b-card-text>
          <b-navbar
            class="formCard w-100 d-block"
            style="
              border-radius: 5px !important;
              padding-left: 0px;
              height: auto !important;
            "
            toggleable="lg"
            type="dark"
            variant="primary"
          >
            <b-row>
              <b-col md="10">
                <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
              </b-col>
              <b-col md="2">
                <b-navbar-nav class="pull-right mr-auto">
                  <b-nav-form>
                    <b-button @click="filterClear">Clear</b-button>
                    <b-button
                      class="ml-1"
                      variant="outline-success"
                      @click="exportMonthTableToExcel"
                      :disabled="monthContainerExportList.length <= 0"
                    >
                      <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    </b-button>
                    <b-button class="ml-1" variant="outline-info" @click="getPDF">
                      <i class="fa fa-cloud-download" aria-hidden="true"></i>
                    </b-button>
                  </b-nav-form>
                </b-navbar-nav>
              </b-col>
            </b-row>
          </b-navbar>

          <b-card>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Date</label>
                <date-range-picker
                  :opens="openLeft"
                  :always-show-calendars="showCal"
                  v-model="dateRange"
                  :startDate="startDate"
                  :endDate="endDate"
                  :locale-data="locale"
                  @update="getTotalVolumes"
                ></date-range-picker>
              </b-col>
              <b-col md="3">
                <label>Type</label>
                <model-list-select
                  :list="transportTypeName"
                  v-model="Filter.transportTypeFilter"
                  option-value="transportTypeVal"
                  option-text="transportTypeText"
                  placeholder="Select Export / Import"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Client</label>
                <model-list-select
                  :list="$store.getters['common/getAllClientList']"
                  id="clientNamenew"
                  v-model="Filter.clientFilter"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Client Name"
                  :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' ? true : false
                  "
                  @input="getTotalVolumes"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Shipping Line</label>
                <model-list-select
                  :list="$store.getters['common/getAllShippingLineList']"
                  v-model="Filter.shippingIdFilter"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                  :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' ? true : false
                  "
                  @input="getTotalVolumes"
                ></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Branch</label>
                <model-list-select
                  :list="$store.getters['common/getAllBranchList']"
                  id="branchFilter"
                  v-model="Filter.branchFilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="All"
                  :isDisabled="
                    $sessionsStorage.get('cust_username') == 'pankajmishra'?false:$sessionsStorage.get('designation') != 'Admin' ? true : false
                  "
                  @input="getTotalVolumes"
                ></model-list-select>
              </b-col>

              <b-col md="3">
                <label>Container Type</label>
                <model-list-select
                  :list="$store.getters['common/getAllContainerTypeList']"
                  v-model="Filter.containerTypeFilter"
                  option-value="containerTypeId"
                  option-text="containerType"
                  placeholder="Select Container Type"
                  @input="getTotalVolumes"
                ></model-list-select>
              </b-col>
            </b-row>
          </b-card>
        </b-card-text>
        <hr />
        <div class="gutr mt-3">
          <div class="row">
            <div class="col-md-12">
              <h6 class="card-title">TOT. CONTAINERS TEUS EXP</h6>
              <div class="fluid-container card" v-if="mainExecutionDetails.totalTUESExec > 0">
                <!-- {{mainExecutionDetails}} -->
                <!-- v-if="mainExecutionDetails.totalExec>0" -->
                <div class="card-body">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th>Execution = {{ mainExecutionDetails.totalExec }}</th>
                        <th>CONTAINERS = {{ mainExecutionDetails.totalContExec }}</th>
                        <th>TEUS = {{ mainExecutionDetails.totalTUESExec }}</th>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th>
                          Export Execution = {{ mainExecutionDetails.totalExpExec }}
                        </th>
                        <th>
                          Export CONTAINERS = {{ mainExecutionDetails.totalExpContExec }}
                        </th>
                        <th>Export TEUS = {{ mainExecutionDetails.totalExpTUESExec }}</th>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th>
                          Import Execution = {{ mainExecutionDetails.totalImpExec }}
                        </th>
                        <th>
                          Import CONTAINERS = {{ mainExecutionDetails.totalImpContExec }}
                        </th>
                        <th>Import TEUS = {{ mainExecutionDetails.totalImpTUESExec }}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              class="col-md-12 mt-2 mb-2 card"
              v-if="
                monthContainerExportList.length > 0 &&
                Filter.transportTypeFilter == 'Export'
              "
            >
              <div class="text-right p-2">
                <b-button
                  size="sm"
                  variant="outline-success"
                  @click="exportMonthTableToExcel('Export')"
                >
                  <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                  Export
                </b-button>
              </div>
              <table class="table table-bordered table-sm card-body">
                <tbody>
                  <tr>
                    <th>SN</th>
                    <th>Month</th>
                    <th>Export Tot Exe</th>
                    <th>Export Tot Containers</th>
                    <th>Export Tot TEUS</th>
                  </tr>

                  <tr
                    v-for="(rev_item, rev_index) in monthContainerExportList"
                    :key="rev_index"
                  >
                    <td>{{ parseInt(rev_index + 1) }}.</td>
                    <td>{{ rev_item.fromDate + " to " + rev_item.toDate }}</td>
                    <td>
                      {{ rev_item.TotSeaExportExe }}
                    </td>
                    <td>
                      {{ rev_item.TotFFSeaExportExeCont }}
                    </td>
                    <td>
                      {{ rev_item.totalExecutionContExpTUES }}
                    </td>
                  </tr>
                  <tr v-if="monthContainerExportList.length <= 0">
                    <td colspan="4" style="text-align: center; color: purple">
                      <b>Data Not Found</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="col-md-12 mt-2 mb-2 card"
              v-if="
                monthContainerExportList.length > 0 &&
                Filter.transportTypeFilter == 'Import'
              "
            >
              <table class="table table-bordered table-sm card-body">
                <tbody>
                  <tr>
                    <th>SN</th>
                    <th>Month</th>
                    <th>Import Tot Exe</th>
                    <th>Import Tot Containers</th>
                    <th>Import Tot TEUS</th>
                  </tr>

                  <tr
                    v-for="(rev_item, rev_index) in monthContainerExportList"
                    :key="rev_index"
                  >
                    <td>{{ parseInt(rev_index + 1) }}.</td>
                    <td>{{ rev_item.fromDate + " to " + rev_item.toDate }}</td>
                    <td>
                      {{ rev_item.TotSeaImportExe }}
                    </td>
                    <td>{{ rev_item.TotFFSeaImportExeCont }}</td>
                    <td>
                      {{ rev_item.totalExecutionContImpTUES }}
                    </td>
                  </tr>
                  <tr v-if="monthContainerExportList.length <= 0">
                    <td colspan="4" style="text-align: center; color: purple">
                      <b>Data Not Found</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <BranchWiseTeusTable :dateRange="dateRange" :filter="Filter" />
            <ClientWiseTeusTable :dateRange="dateRange" :filter="Filter" />
            <ShippingLineWiseTeusTable :dateRange="dateRange" :filter="Filter" />
            <ContainerTypeWiseTeusTable :dateRange="dateRange" :filter="Filter" />
            <b-row>
              <b-col md="12" class="mt-5" v-if="$store.getters.appDeviceType != 'Phone'">
                <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div>
                        <h6 class="card-title">TOTAL Volume Chart</h6>
                        <div class="fluid-container"></div>
                        <div id="chart1">
                          <!-- {{series}} -->
                          <apexchart
                            v-if="series.length > 0"
                            type="pie"
                            class="mt-3"
                            height="600"
                            width="1200"
                            :options="chartOptions"
                            :series="series"
                          ></apexchart>
                          <!-- {{ ContainerchartOptions }}
                          {{ Containerseries }} -->
                          <!-- <apexchart
                            v-if="Containerseries[2].data.length > 0"
                            type="bar"
                            class="mt-3"
                            height="800"
                            width="1300"
                            :options="ContainerchartOptions"
                            :series="Containerseries"
                          ></apexchart> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="row gutr"></div>
      </b-card>
      <b-card v-else class="mainCardBG">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand v-if="showDash == false">
            <h4 class="page-title" v-if="employeeName != ''">
              Welcome
              <small>{{ employeeName }}</small>
            </h4>
          </b-navbar-brand>
        </b-navbar>
      </b-card>
    </section>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BranchWiseTeusTable from "./BranchWiseTeusTable.vue";
import ClientWiseTeusTable from "./ClientWiseTeusTable.vue";
import ShippingLineWiseTeusTable from "./ShippingLineWiseTeusTable.vue";
import ContainerTypeWiseTeusTable from "./ContainerTypeWiseTeusTable.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import ProfitLossService from "../../services/ProfitLossService.js";
import * as XLSX from "xlsx";
export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );

      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );

      this.$store.dispatch("setCurrentRoute", this.$router.path);

      // this.getCurrentLastDate();
      this.getTotalVolumes();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    BranchWiseTeusTable,
    ClientWiseTeusTable,
    ShippingLineWiseTeusTable,
    ContainerTypeWiseTeusTable,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {},
  data() {
    return {
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      Filter: {
        transportTypeFilter: "Export",
        clientFilter: "",
        shippingIdFilter: "",
        branchFilter: "",
        PODfilter: "",
        containerTypeFilter: "",
      },

      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "right",
      showCal: false,
      showDash: true,

      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      employeeName: "",
      employeeLoc: "",

      isLoading: false,

      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      DateRangeContexecDataCount: [],
      monthContainerExportList: [],
      monthContainerExportListGraph: [],
      mainExecutionDetails: {
        totalExec: 0,
        totalExpExec: 0,
        totalImpExec: 0,

        totalContExec: 0,
        totalExpContExec: 0,
        totalImpContExec: 0,

        totalTUESExec: 0,
        totalExpTUESExec: 0,
        totalImpTUESExec: 0,
      },

      series: [],
      chartOptions: {
        plotOptions: {
          pie: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          width: 200,
          type: "pie",
        },
        labels: [],

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    exportMonthTableToExcel(transportType = null) {
      if (!this.monthContainerExportList || this.monthContainerExportList.length <= 0) return;

      const effectiveType = transportType || this.Filter.transportTypeFilter;
      const isImport = effectiveType == "Import";
      const header = [
        "SN",
        "Month",
        isImport ? "Import Tot Exe" : "Export Tot Exe",
        isImport ? "Import Tot Containers" : "Export Tot Containers",
        isImport ? "Import Tot TEUS" : "Export Tot TEUS",
      ];

      const rows = this.monthContainerExportList.map((item, index) => [
        index + 1,
        `${item.fromDate} to ${item.toDate}`,
        isImport ? item.TotSeaImportExe || 0 : item.TotSeaExportExe || 0,
        isImport
          ? item.TotFFSeaImportExeCont || 0
          : item.TotFFSeaExportExeCont || 0,
        isImport
          ? item.totalExecutionContImpTUES || 0
          : item.totalExecutionContExpTUES || 0,
      ]);

      const sheetData = [header, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      ws["!cols"] = [
        { wch: 8 },
        { wch: 24 },
        { wch: 18 },
        { wch: 22 },
        { wch: 16 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Monthly TUES");
      const date = new Date();
      const stamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`;
      XLSX.writeFile(
        wb,
        `Monthly_${isImport ? "Import" : "Export"}_TUES_${stamp}.xlsx`,
      );
    },

    clearMonthContainerExportChartData() {
      this.monthContainerExportList = [];
      this.mainExecutionDetails = {
        totalExec: 0,
        totalExpExec: 0,
        totalImpExec: 0,

        totalContExec: 0,
        totalExpContExec: 0,
        totalImpContExec: 0,

        totalTUESExec: 0,
        totalExpTUESExec: 0,
        totalImpTUESExec: 0,
      };
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.getPortDischargeList = result;
            }
          }
        });
        console.log("self[vmodelArray]=>", self);
      }
    },

    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getTotalVolumes();
    },

    goBack() {
      window.history.go(-1);
    },

    filterClear() {
      this.Filter = {
        transportTypeFilter: "Export",
        clientFilter: "",
        shippingIdFilter: "",
        branchFilter: "",
        PODfilter: "",
        containerTypeFilter: "",
      };
      this.dateSearch.fromDate = "";
      this.dateSearch.toDate = "";
      this.monthContainerExportList = [];
      this.monthContainerExportListGraph = [];
      this.getCurrentLastDate();
      this.getTotalVolumes();
    },

    getTotalVolumes() {
      this.isLoading = true;
      this.showDash = true;
      this.clearMonthContainerExportChartData();
      let payload = {
        itemCode: "getAllVolumesTEUS",
        dateRange: this.dateRange,
        Filter: this.Filter,
      };

      ProfitLossService.getAllProfitLoss(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("Priyanshu Singh=>", response);
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            } else {
              console.log("data.userDetails PS=>", data);
              if (data.userDetails.length > 0) {
                if (data.userDetails[0].dashBoardPermission == "Yes") {
                  this.showDash = true;
                } else {
                  this.showDash = true;
                  if (data.userDetails[0].type == "1") {
                    this.employeeName = (data.userDetails[0].employeeName || "").toUpperCase();
                    this.employeeLoc = (data.userDetails[0].employeeLoc || "").toUpperCase();
                  }
                }
              }

              if (data.DateRangeContexecDataCount.length > 0) {
                this.series = data.TotalExecutionChartData;
                for (let q = 0; q < data.TotalExecutionChartLabelData.length; q++) {
                  this.chartOptions.labels.push(data.TotalExecutionChartLabelData[q]);
                }
                this.monthContainerExportList = data.DateRangeContexecDataCount;
                this.mainExecutionDetails = {
                  totalExec: data.totalExec,
                  totalExpExec: data.totalExpExec,
                  totalImpExec: data.totalImpExec,

                  totalContExec:
                    parseInt(data.totalExpContExec) + parseInt(data.totalImpContExec),
                  totalExpContExec: data.totalExpContExec,
                  totalImpContExec: data.totalImpContExec,

                  totalTUESExec: data.totalTUESExec,
                  totalExpTUESExec: data.totalExpTUESExec,
                  totalImpTUESExec: data.totalImpTUESExec,
                };
              }
              console.log("this.mainExecutionDetails=>", this.mainExecutionDetails);
              // top Container Type chart

              this.isLoading = false;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },

    // Added By Priyanshu Singh Start
    download() {
      let windowHeight = window.outerHeight;
      let windowWidth = window.outerWidth;

      let pdf = new jsPDF();

      let canvasElement = document.createElement("canvas");
      canvasElement.width = 4000;
      canvasElement.height = 4000;

      html2canvas(this.$refs.TUESVolumeCardpdf, {
        canvas: canvasElement,
        width: windowWidth,
        height: windowHeight,
      })
        .then((canvas) => {
          const img = canvas.toDataURL("image/jpeg", 5);
          document.body.appendChild(canvas);
          pdf.addImage(img, "JPEG", 10, 10);
          pdf.save("sample.pdf");

          alert("works");
        })
        .catch((err) => {
          alert("error");
        });
    },
    getPDF() {
      var HTML_Width = $("#TUESVolumeCardpdf").width();
      var HTML_Height = $("#TUESVolumeCardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#TUESVolumeCardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        // console.log(canvas.height + "  " + canvas.width);

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }
        var date = new Date();
        var timestamp = date.getTime();

        pdf.save("FF_POD_SHIPPING_LINE_EXP_DASHBOARD_" + timestamp + ".pdf");
      });
    },
    // Added By Priyanshu Singh End
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 315px !important;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>



// WEBPACK FOOTER //
// tuesVolumeCard.vue?037bb872